<script>
import { useInfiniteScroll } from '@vueuse/core';
import { getValidatedToolTip } from '@/utils/helper-function';
import NoData from '@/rex-components/rex-no-data.vue';
import RexSpinV3 from '@/rex-components/RexSpinV3.vue';
import { nextTick } from 'vue';

export default {
  emits: ['onChange', 'loadMoreData'],
  components: {
    NoData,
    RexSpinV3,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      default: 'checkbox',
    },
    checkedItems: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listEl: null,
    };
  },
  computed: {
    getInputStyle() {
      return this.type === 'radio'
        ? this.$style.inputFieldRadio
        : this.$style.inputFieldCheckbox;
    },
    isListOptionsExist() {
      return this.options.length > 0;
    },
  },
  methods: {
    getValidatedToolTip,
    inActiveListItem(value) {
      return (
        !this.checkedItems.includes(value) && this.checkedItems.length === 5
      );
    },
    initializeInfiniteScroll() {
      useInfiniteScroll(this.listEl, () => {
        if (
          this.listEl &&
          this.listEl.scrollTop + this.listEl.offsetHeight >=
            this.listEl.scrollHeight - 10 &&
          !this.isLoading
        ) {
          this.$emit('loadMoreData');
        }
      });
    },
  },
  mounted() {
    this.listEl = this.$refs?.listEl;
    this.initializeInfiniteScroll();
  },
  watch: {
    options() {
      if (this.options.length > 0) {
        nextTick(() => {
          this.listEl = this.$refs?.listEl;
          this.initializeInfiniteScroll();
        });
      }
    },
  },
};
</script>

<template>
  <div>
    <ul ref="listEl" :class="$style.listBox" v-if="isListOptionsExist">
      <li :class="$style.listItems" v-for="(item, i) in options" :key="i">
        <input
          :type="type"
          name="fields"
          :id="item.value"
          :class="[
            getInputStyle,
            inActiveListItem(item.value) && $style.inActiveField,
          ]"
          :value="item.value"
          @change="(event) => $emit('onChange', event, item.name, item.isGroup)"
          :checked="checkedItems.includes(item.value)"
        />
        <label
          :for="item.value"
          :class="[
            $style.fieldLabel,
            inActiveListItem(item.value) && $style.inActiveFieldLabel,
          ]"
          v-tooltip:top="getValidatedToolTip(item.name, 20)"
        >
          {{ item.name }}
        </label>
      </li>
      <RexSpinV3
        v-if="isLoading"
        size="small"
        :style="{ marginBottom: '1rem' }"
      />
    </ul>
    <div v-else :class="$style.nodataBox">
      <NoData :message="$t('log.noData')" />
    </div>
  </div>
</template>

<style lang="scss" module>
.listBox {
  list-style: none;
  padding-left: 0rem;
  margin-top: 1.313rem;
  height: 50rem;
  overflow-y: scroll;
}
.listItems {
  display: flex;
  align-items: center;
  margin: 1.156rem 0rem;
}
.fieldLabel {
  margin-bottom: 0rem;
  margin-left: 0.938rem;
  cursor: pointer;
  @include truncate(10.9rem);
}
.inputFieldRadio {
  @include custom-radio-checkbox($type: 'radio');
}
.inputFieldRadio::before {
  @include custom-radio-checkbox-before($type: 'radio');
}
.inputFieldRadio:checked::before {
  @include custom-radio-checkbox-checked-before;
}
.inputFieldCheckbox {
  @include custom-radio-checkbox($type: 'checkbox');
}
.inputFieldCheckbox::before {
  @include custom-radio-checkbox-before($type: 'checkbox');
}
.inputFieldCheckbox:checked::before {
  @include custom-radio-checkbox-checked-before;
}
.inActiveField::before {
  @include custom-radio-checkbox-before(
    $type: 'checkbox',
    $fill-color: #303030
  );
  @include custom-radio-checkbox($type: 'checkbox', $border-color: #303030);
  @include custom-radio-checkbox-checked-before;
}
.inActiveFieldLabel {
  color: $border-grey;
  cursor: not-allowed;
  pointer-events: none;
}
.nodataBox {
  height: 50rem;
  @include flex-center;
}
</style>
